export const tinyEditorTypes = {
  TEXT: 'Text',
  LIST: 'List',
  TABLE: 'Table',
  IMAGE: 'Image',
  HTML: 'Html',
}

export const tinyEditorConfig = {
  [tinyEditorTypes.TEXT]: {
    toolbar: 'code | styles | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | table',
    plugins: ["advlist", "anchor", "autolink", "charmap", "code", "fullscreen",
      "help", "image", "insertdatetime", "link", "lists", "media",
      "preview", "searchreplace", "table", "visualblocks",],
    init: {
      style_formats: [
        {
          title: 'Headings',
          items: [
            { title: 'Heading 1', format: 'h1' },
            { title: 'Heading 2', format: 'h2' },
            { title: 'Heading 3', format: 'h3' },
            { title: 'Heading 4', format: 'h4' },
            { title: 'Heading 5', format: 'h5' },
            { title: 'Heading 6', format: 'h6' },
          ]
        },
        {
          title: 'Inline',
          items: [
            { title: 'Bold', format: 'bold' },
            { title: 'Italic', format: 'italic' },
            { title: 'Underline', format: 'underline' },
            { title: 'Strikethrough', format: 'strikethrough' },
            { title: 'Superscript', format: 'superscript' },
            { title: 'Subscript', format: 'subscript' },
            { title: 'Code', format: 'code' },

            { title: 'Disclaimer', classes: 'disclaimer', selector: 'p' },
          ]
        },
        {
          title: 'Blocks',
          items: [
            { title: 'Paragraph', format: 'p' },
            { title: 'Blockquote', format: 'blockquote' },
            { title: 'Div', format: 'div' },
            { title: 'Pre', format: 'pre' }
          ]
        },
        {
          title: 'Align',
          items: [
            { title: 'Left', format: 'alignleft' },
            { title: 'Center', format: 'aligncenter' },
            { title: 'Right', format: 'alignright' },
            { title: 'Justify', format: 'alignjustify' }
          ]
        }
      ],
      images_file_types: "jpg,jpeg,png",
          automatic_uploads: true,
          paste_data_images: true,
          images_upload_handler: (blobInfo) =>
          new Promise((resolve, reject) => {
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (blobInfo.blob().size > maxSize) {
              reject("Image too large (max. 5MB)");
              return;
            }

            const reader = new FileReader();

            reader.onload = () => {
              resolve(reader.result);
            };

            reader.onerror = () => {
              reject("Error converting image");
            };

            reader.readAsDataURL(blobInfo.blob());
          }),
    }
  },
  [tinyEditorTypes.LIST]: {
  toolbar: 'bullist | numlist | outdent | indent',
  plugins: ['lists', 'advlist'],
    init: {
      advlist_number_styles: 'default,lower-alpha,upper-alpha,lower-roman,upper-roman',
      advlist_bullet_styles: 'default,disc,circle,square',
    }
  },
  [tinyEditorTypes.TABLE]: {
    toolbar: 'table',
    plugins: ['table'],
    init: {}
  },
  [tinyEditorTypes.IMAGE]: {
    toolbar: 'image | alignjustify | alignleft | aligncenter | alignright | alignnone',
    plugins: ['image'],
    init: {
      images_file_types: "jpg,jpeg,png",
          automatic_uploads: true,
          paste_data_images: true,
          images_upload_handler: (blobInfo) =>
          new Promise((resolve, reject) => {
            const maxSize = 5 * 1024 * 1024; // 5MB

            if (blobInfo.blob().size > maxSize) {
              reject("Image too large (max. 5MB)");
              return;
            }

            const reader = new FileReader();

            reader.onload = () => {
              resolve(reader.result);
            };

            reader.onerror = () => {
              reject("Error converting image");
            };

            reader.readAsDataURL(blobInfo.blob());
          }),
    }
  },
  [tinyEditorTypes.HTML]: {
    toolbar: 'code',
    plugins: ['code'],
    init: {}
  }
}